"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const lodash_1 = __importDefault(require("lodash"));
const date_fns_1 = require("date-fns");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../helper");
const CONTENT = helper_1.REQUEST.content || '';
const DATE_FORMAT = 'yyyy-MM-dd';
const FILTER = {
    assignedUser: 'assignedUser',
    reviewStatus: 'reviewStatus',
    reviewDeadline: 'dueDate',
    reviewOwner: 'reviewOwner',
    reviewStage: 'reviewStage',
    reviewTypes: 'reviewTypes',
    office: 'office',
    brand: 'brand',
    project: 'project',
    projectManager: 'projectManager',
    reviewRound: 'reviewRound',
    dueDateCustom: 'dueDateCustom',
};
const USER_FILTER_URL = `/v2/api/users?filter[access_not_in][]=deleted&filter[access_not_in][]=suspended`;
const allowFilters = [
    {
        name: FILTER.assignedUser,
        PulseSelectBaseProps: {
            labelName: 'ASSIGNED TO',
            placeholder: 'Search for User...',
            url: USER_FILTER_URL,
            variant: 'select2',
        },
    },
    {
        name: FILTER.reviewStatus,
        PulseSelectBaseProps: {
            classes: {
                root: styles_modules_less_1.default['select-option__root'],
            },
            labelName: 'REVIEW STATUS',
            placeholder: 'Search for Status...',
            variant: 'select2',
        },
    },
    {
        name: FILTER.reviewDeadline,
        PulseSelectBaseProps: {
            labelName: 'REVIEW DEADLINE',
            placeholder: 'Select...',
            staticOptions: [{ value: 'custom', label: 'Custom' }],
            variant: 'select2',
        },
    },
    {
        name: FILTER.reviewOwner,
        PulseSelectBaseProps: {
            labelName: 'REVIEW OWNER',
            placeholder: 'Search for Review Owners...',
            url: USER_FILTER_URL,
            variant: 'select2',
        },
    },
    {
        name: FILTER.reviewStage,
        PulseInputProps: {
            classes: {
                label: styles_modules_less_1.default.input__label,
            },
            InputBaseProps: {
                classes: {
                    root: styles_modules_less_1.default['input-base__root'],
                },
                placeholder: 'Search for Review Stage...',
            },
        },
    },
    {
        name: FILTER.reviewTypes,
        PulseSelectBaseProps: {
            labelName: 'REVIEW TYPE',
            placeholder: 'Search for Review Type...',
            url: `/v2/api/round-types?filter[is_active]=1`,
            variant: 'select2',
        },
    },
    {
        name: FILTER.office,
        PulseSelectBaseProps: {
            labelName: 'OFFICE',
            placeholder: 'Search for Office...',
            variant: 'select2',
        },
    },
    {
        name: FILTER.brand,
        PulseSelectBaseProps: {
            labelName: 'BRAND',
            placeholder: 'Search for Brand...',
            variant: 'select2',
        },
    },
    {
        name: FILTER.project,
        PulseSelectBaseProps: {
            labelName: 'PROJECT',
            placeholder: 'Search for Project...',
            url: `/v2/api/jobs`,
            variant: 'select2',
        },
    },
    {
        name: FILTER.projectManager,
        PulseSelectBaseProps: {
            labelName: 'PROJECT MANAGER',
            placeholder: 'Search for Project Manager...',
            url: USER_FILTER_URL,
            variant: 'select2',
        },
    },
    {
        name: FILTER.reviewRound,
        PulseSelectBaseProps: {
            labelName: 'REVIEW ROUND',
            placeholder: 'Search for Review Rounds...',
            variant: 'select2',
        },
    },
];
const FILTER_TO_DEEP_LINK = {
    member_id: 'assignedUser',
    status_id: 'reviewStatus',
    brand_id: 'brand',
    office_id: 'office',
    owner_id: 'reviewOwner',
    job_id: 'project',
    round_type_id: 'reviewTypes',
    project_manager_id: 'projectManager',
    round_number: 'reviewRound',
    name: 'reviewStage',
    deadline_start: 'dueDate',
    deadline_end: 'dueDate',
};
const ReviewFilter = react_1.default.forwardRef((props, ref) => {
    const refFilter = ref;
    const { handleFilterFlyout } = props;
    const [initFilter, setInitFilter] = (0, react_1.useState)({});
    const deeplinkToFilter = () => {
        var _a, _b;
        const filter = {};
        const deepLinks = (_b = (_a = window.pulse) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.deepLinks;
        if (lodash_1.default.isEmpty(deepLinks)) {
            return {};
        }
        Object.keys(deepLinks).forEach((key) => {
            var _a, _b;
            const filterValue = [];
            if (key === 'name') {
                filter[key] = deepLinks.name;
            }
            else {
                Object.keys(deepLinks[key]).forEach((deepLinkValue) => {
                    if (key !== 'round_number') {
                        const formatObject = {
                            value: deepLinkValue,
                            label: deepLinks[key][deepLinkValue],
                        };
                        filterValue.push(formatObject);
                    }
                    else {
                        const roundObject = {
                            value: deepLinks[key][deepLinkValue],
                            label: `Round ${deepLinks[key][deepLinkValue]}`,
                        };
                        filterValue.push(roundObject);
                    }
                });
            }
            if (key !== 'name') {
                filter[key] = filterValue;
            }
            if (filter.deadline_start && filter.deadline_end) {
                const startDateValue = (_a = filter.deadline_start[0]) === null || _a === void 0 ? void 0 : _a.value;
                const endDateValue = (_b = filter.deadline_end[0]) === null || _b === void 0 ? void 0 : _b.value;
                filter.dueDate = { value: 'custom', label: 'Custom' };
                filter.dueDateCustom = {
                    startDate: startDateValue,
                    endDate: endDateValue,
                };
            }
        });
        return utilities_1.default.renameKeys(filter, FILTER_TO_DEEP_LINK);
    };
    (0, react_1.useEffect)(() => {
        setInitFilter(deeplinkToFilter());
    }, []);
    const onApplyFilter = (filter) => {
        var _a;
        const roundIDByDeepLink = window.location.hash.replace('#', '');
        // doing deep link
        if (roundIDByDeepLink && CONTENT === 'passport-reviews') {
            return;
        }
        const filterObj = {};
        Object.entries(filter).forEach(([filterKey, filterValues]) => {
            if (filterValues.length <= 0) {
                return;
            }
            switch (filterKey) {
                case FILTER.assignedUser:
                    if (filterValues) {
                        filterObj.member_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.brand:
                    if (filterValues) {
                        filterObj.brand_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.office:
                    if (filterValues) {
                        filterObj.office_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.project:
                    if (filterValues) {
                        filterObj.job_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.dueDateCustom:
                    filterObj.deadline_start = (0, date_fns_1.format)(new Date(filterValues.startDate), DATE_FORMAT);
                    filterObj.deadline_end = (0, date_fns_1.format)(new Date(filterValues.endDate), DATE_FORMAT);
                    break;
                case FILTER.reviewStatus:
                    if (filterValues) {
                        filterObj.status_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.reviewOwner:
                    if (filterValues) {
                        filterObj.owner_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.reviewTypes:
                    if (filterValues) {
                        filterObj.round_type_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.projectManager:
                    if (filterValues) {
                        filterObj.project_manager_id = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                case FILTER.reviewStage:
                    if (filterValues) {
                        filterObj.name = filterValues || [];
                    }
                    break;
                case FILTER.reviewRound:
                    if (filterValues) {
                        filterObj.round_number = filterValues.map((attribute) => attribute.value || []);
                    }
                    break;
                default:
                    break;
            }
        });
        const formatFilterObj = (0, helper_1.filterParams)(filterObj);
        const filterEvent = new CustomEvent('filter-flyout-change', {
            detail: {
                filterData: formatFilterObj,
            },
        });
        document.dispatchEvent(filterEvent);
        handleFilterFlyout(filter);
        const param = `${(0, utilities_1.stringifyQueryString)(filterObj)}`;
        window.history.pushState('', '', `${window.location.pathname}${param}`);
        (_a = refFilter === null || refFilter === void 0 ? void 0 : refFilter.current) === null || _a === void 0 ? void 0 : _a.closeForm();
    };
    const onResetFilterCustom = () => {
        const filterEvent = new CustomEvent('reset-filter-left-nav', {
            detail: {},
        });
        document.dispatchEvent(filterEvent);
    };
    return (react_1.default.createElement("div", { key: JSON.stringify(initFilter) },
        react_1.default.createElement(pulse_components_1.PulseFilter, { ref: ref, filterTitle: 'FILTERS: REVIEWS', filterInitialValue: initFilter, onApplyFilter: onApplyFilter, allowFilters: allowFilters, onResetFilterCustom: onResetFilterCustom })));
});
exports.default = ReviewFilter;
